import { cssProps } from '@oracle/oraclejet-cssprops';
import { Property } from 'csstype';
import keys from 'ramda/src/keys';

const alignSelfStyles = {
  baseline: cssProps`${{
    alignSelf: 'baseline'
  }}`,

  center: cssProps`${{
    alignSelf: 'center'
  }}`,

  end: cssProps`${{
    alignSelf: 'flex-end'
  }}`,

  start: cssProps`${{
    alignSelf: 'flex-start'
  }}`,

  inherit: cssProps`${{
    alignSelf: 'inherit'
  }}`,

  initial: cssProps`${{
    alignSelf: 'initial'
  }}`,

  stretch: cssProps`${{
    alignSelf: 'stretch'
  }}`
};

const flexitemStyles = {
  alignSelf: alignSelfStyles
};

const alignSelfs = keys(alignSelfStyles);

export type FlexitemProps = {
  alignSelf?: keyof typeof alignSelfStyles;
  flex?: Property.Flex;
  order?: Property.Order;
};

const flexitemInterpolations = {
  alignSelf: ({ alignSelf }: Pick<FlexitemProps, 'alignSelf'>) =>
    alignSelf === undefined
      ? {}
      : {
          class: alignSelfStyles[alignSelf]
        },
  flex: ({ flex }: Pick<FlexitemProps, 'flex'>) => (flex === undefined ? {} : { flex }),
  order: ({ order }: Pick<FlexitemProps, 'order'>) => (order === undefined ? {} : { order })
};

export { alignSelfs, flexitemInterpolations, flexitemStyles };
